import { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DoubleListBoxContext } from '@bingads-webui-react/double-list-box-fluent';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { getCampaignsFromProp } from '@bingads-webui-campaign-react/brand-lists-data';

export const DataSource = ({ type, onCampaignLoaded }) => {
  const {
    state: {
      pageNumber,
      search,
    },
    dispatch,
  } = useContext(DoubleListBoxContext);
  const serverContext = useContext(ServerContext);
  const getCampaigns = getCampaignsFromProp({
    cid: serverContext.CurrentCustomer.Id,
    aid: serverContext.CurrentAccount.Id,
  });

  useEffect(() => {
    let isMounted = true;
    async function loadData() {
      dispatch({ type: 'START_LOAD_DATA' });
      const campaignTypeMap = {
        protection: 'Default',
        exclusion: 'PerformanceMax',
      };
      const res = await getCampaigns({ campaignType: campaignTypeMap[type], search, pageNumber });
      if (!isMounted) {
        return;
      }
      dispatch({
        type: 'FINISH_LOAD_DATA',
        payload: {
          items: res.value.map(v => ({
            id: v.Id,
            name: v.Name,
          })),
          totalCount: res['@odata.count'],
          pageNumber: 1,
        },
      });
      onCampaignLoaded(res);
    }
    loadData();

    return () => {
      isMounted = false;
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber, search]);

  return null;
};

DataSource.propTypes = {
  type: PropTypes.string.isRequired,
  onCampaignLoaded: PropTypes.func.isRequired,
};
